/* siel-favorites.js
   - Variant-level favorites stored in localStorage
   - Modal UI: Color heading -> size rows with heart
*/

(function () {
  const STORAGE_KEY = "siel_favorites_v1";

  function loadFavs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  function saveFavs(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("siel:favorites:changed", { detail: list }));
  }

  function isFav(variantId) {
    return loadFavs().some((x) => String(x.variantId) === String(variantId));
  }

  function toggleFav(item) {
    const list = loadFavs();
    const idx = list.findIndex((x) => String(x.variantId) === String(item.variantId));
    if (idx >= 0) list.splice(idx, 1);
    else list.unshift(item);
    saveFavs(list);
    return idx < 0;
  }

  function moneyFromCents(cents, currencySymbol = "¥") {
    if (typeof cents !== "number") return "";
    const yen = Math.round(cents / 100);
    return currencySymbol + yen.toLocaleString("ja-JP");
  }

  function getProductDataFromDom() {
    const el = document.getElementById("siel-product-json");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // ---- Image helpers (fix) ----
  function normalizeShopifyImg(url) {
    if (!url) return "";
    const u = String(url);

    // //cdn... → https://cdn...
    if (u.startsWith("//")) return "https:" + u;

    // /cdn/... or /files/... → absolute
    if (u.startsWith("/")) {
      try {
        return new URL(u, window.location.origin).toString();
      } catch (e) {
        return u;
      }
    }

    return u;
  }

  function pickVariantImage(v, product) {
    // 1) variant.featured_image
    const vi = v?.featured_image;
    if (vi) {
      const raw = vi.src || vi.url || vi;
      const n = normalizeShopifyImg(raw);
      if (n) return n;
    }

    // 2) product.featured_image
    const pi = product?.featured_image;
    if (pi) {
      const raw = pi.src || pi.url || pi;
      const n = normalizeShopifyImg(raw);
      if (n) return n;
    }

    // 3) product.images[0]
    const img0 = Array.isArray(product?.images) ? product.images[0] : null;
    if (img0) {
      const raw = img0.src || img0.url || img0;
      const n = normalizeShopifyImg(raw);
      if (n) return n;
    }

    // 4) product.media image preview
    const m0 = Array.isArray(product?.media)
      ? product.media.find((m) => m?.media_type === "image" && m?.preview_image?.src)
      : null;
    if (m0?.preview_image?.src) {
      const n = normalizeShopifyImg(m0.preview_image.src);
      if (n) return n;
    }

    return "";
  }
  // ---- /Image helpers ----

  function groupVariantsByColor(variants, colorIndex) {
    const map = new Map();
    variants.forEach((v) => {
      const color = v.options?.[colorIndex] || "その他";
      if (!map.has(color)) map.set(color, []);
      map.get(color).push(v);
    });

    // sizes order = as-is
    return Array.from(map.entries()).map(([color, list]) => {
      return { color, list };
    });
  }

  function buildModalRows(product) {
    const modal = document.getElementById("siel-fav-modal");
    const body = modal?.querySelector("[data-siel-fav-body]");
    if (!modal || !body || !product) return;

    const variants = product.variants || [];
    const optionNames = (product.options || []).map((o) => o.name);

    // 想定：option1=Color / option2=Size
    const colorIndex = 0;
    const sizeIndex = 1;

    const groups = groupVariantsByColor(variants, colorIndex);

    const html = [];
    groups.forEach((g) => {
      html.push(`<div class="siel-fav__group">`);
      html.push(`
        <div class="siel-fav__groupTitle">
          <span class="siel-fav__swatch" aria-hidden="true"></span>
          <span class="siel-fav__color">${escapeHtml(g.color)}</span>
        </div>
      `);

      g.list.forEach((v) => {
        const size = v.options?.[sizeIndex] || (optionNames[sizeIndex] ? "選択" : "");
        const available = !!v.available;
        const active = isFav(v.id);

        // ✅ ここを差し替え（画像の取り方を強化）
        const img = pickVariantImage(v, product);

        const priceText = typeof v.price === "number" ? moneyFromCents(v.price) : "";

        html.push(`
          <button class="siel-fav__row ${available ? "" : "is-soldout"}" type="button"
            data-siel-variant-row
            data-variant-id="${v.id}"
            data-variant-title="${escapeAttr(product.title)}"
            data-variant-options="${escapeAttr((v.options || []).join(" / "))}"
            data-variant-url="${escapeAttr((product.url || location.pathname) + "?variant=" + v.id)}"
            data-variant-image="${escapeAttr(img || "")}"
            data-variant-price="${escapeAttr(priceText || "")}"
            aria-label="${escapeAttr(g.color + " " + size)}"
          >
            <div class="siel-fav__rowLeft">
              <div class="siel-fav__sizeLine">
                <span class="siel-fav__size">${escapeHtml(size)}</span>
                <span class="siel-fav__stock">${available ? "在庫あり" : "在庫なし"}</span>
              </div>
              <div class="siel-fav__sub">${escapeHtml((v.options || []).join(" / "))}</div>
            </div>

            <span class="siel-fav__heart ${active ? "is-active" : ""}" data-siel-heart aria-hidden="true">♥</span>
          </button>
        `);
      });

      html.push(`</div>`);
    });

    body.innerHTML = html.join("");
  }

  function openModal() {
    const modal = document.getElementById("siel-fav-modal");
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("siel-favModal-open");
  }

  function closeModal() {
    const modal = document.getElementById("siel-fav-modal");
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("siel-favModal-open");
  }

  function bindModalEvents(product) {
    const modal = document.getElementById("siel-fav-modal");
    if (!modal) return;

    modal.addEventListener("click", (e) => {
      const closeBtn = e.target.closest("[data-siel-fav-close]");
      if (closeBtn) {
        closeModal();
        return;
      }

      const row = e.target.closest("[data-siel-variant-row]");
      if (row) {
        const item = {
          variantId: row.getAttribute("data-variant-id"),
          title: row.getAttribute("data-variant-title"),
          options: row.getAttribute("data-variant-options"),
          url: row.getAttribute("data-variant-url"),
          image: row.getAttribute("data-variant-image"),
          price: row.getAttribute("data-variant-price"),
          addedAt: Date.now(),
        };

        const becameFav = toggleFav(item);
        const heart = row.querySelector("[data-siel-heart]");
        if (heart) heart.classList.toggle("is-active", becameFav);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });

    window.addEventListener("siel:favorites:changed", () => buildModalRows(product));
  }

  function bindProductButton(product) {
    const btn = document.querySelector("[data-siel-open-fav]");
    if (!btn) return;

    btn.addEventListener("click", () => {
      buildModalRows(product);
      openModal();
    });
  }

  // Favorites page renderer
  function renderFavoritesPage() {
    const root = document.querySelector("[data-siel-favorites-page]");
    if (!root) return;

    const listEl = root.querySelector("[data-siel-favorites-list]");
    const emptyEl = root.querySelector("[data-siel-favorites-empty]");
    if (!listEl || !emptyEl) return;

    function draw() {
      const favs = loadFavs();
      if (favs.length === 0) {
        listEl.innerHTML = "";
        emptyEl.hidden = false;
        return;
      }
      emptyEl.hidden = true;

      listEl.innerHTML = favs
        .map((x) => {
          const img = x.image
            ? `<img src="${escapeAttr(x.image)}" alt="" loading="lazy">`
            : `<div class="siel-favCard__ph"></div>`;

          return `
            <div class="siel-favCard" data-vid="${escapeAttr(x.variantId)}">
              <a class="siel-favCard__img" href="${escapeAttr(x.url)}">${img}</a>
              <div class="siel-favCard__info">
                <a class="siel-favCard__title" href="${escapeAttr(x.url)}">${escapeHtml(x.title || "")}</a>
                <div class="siel-favCard__opt">${escapeHtml(x.options || "")}</div>
                <div class="siel-favCard__meta">
                  <span class="siel-favCard__price">${escapeHtml(x.price || "")}</span>
                  <button class="siel-favCard__remove" type="button" data-remove="${escapeAttr(x.variantId)}">削除</button>
                </div>
              </div>
            </div>
          `;
        })
        .join("");
    }

    listEl.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-remove]");
      if (!btn) return;
      const vid = btn.getAttribute("data-remove");
      const favs = loadFavs().filter((x) => String(x.variantId) !== String(vid));
      saveFavs(favs);
      draw();
    });

    window.addEventListener("siel:favorites:changed", draw);
    draw();
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }
  function escapeAttr(str) {
    return escapeHtml(str).replaceAll("\n", " ");
  }

  document.addEventListener("DOMContentLoaded", () => {
    const product = getProductDataFromDom();
    if (product) {
      bindProductButton(product);
      bindModalEvents(product);
    }
    renderFavoritesPage();
  });
})();
